import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';

import type { LC_ScreenPreferenceOut, LC_UpdateScreenPreferenceIn } from './userPreference.types';


export class UserPreferenceService {
  /**
   * Gets the authenticated user's preferences for a screen. When the screen has no
   * preferences registered yet, the backend returns preferencesJson: "{}" (not an error).
   */
  async getScreenPreference(
    screenCode: string,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_ScreenPreferenceOut>> {
    return apiClient.get<LC_ScreenPreferenceOut>(
      API_CONFIG.ENDPOINTS.USER_PREFERENCES.SCREEN(screenCode),
      { signal },
    );
  }

  /** Saves (upsert) the authenticated user's preferences for a screen. */
  async updateScreenPreference(
    screenCode: string,
    preferencesJson: string,
  ): Promise<ApiResponse<LC_ScreenPreferenceOut>> {
    const input: LC_UpdateScreenPreferenceIn = { preferencesJson };
    return apiClient.put<LC_ScreenPreferenceOut>(
      API_CONFIG.ENDPOINTS.USER_PREFERENCES.SCREEN(screenCode),
      input,
    );
  }
}

export const userPreferenceService = new UserPreferenceService();
